import { IconCircle } from '@/components/CircleIcon'
import { cn } from '@/utlis/cn'

type EmptyTabProps = {
    className?: string
    icon: React.ReactNode
    text: string
    subtext?: string
}
export function EmptyTab(props: EmptyTabProps) {
    return (
        <div
            className={cn(
                'relative h-full w-full flex flex-col items-center justify-center overflow-visible',
                props.className
            )}
        >
            <div className="absolute w-full h-1/3 top-[40%] flex flex-col gap-2 justify-start items-center">
                <IconCircle className="w-[63px] h-[63px] text-muse-fg/70 backdrop-blur-xs">{props.icon}</IconCircle>
                <div className="t-lg w-full flex flex-col items-center justify-center gap-2">
                    <div>{props.text}</div>
                    <div className="t-base-light opacity-65 text-center">{props.subtext}</div>
                </div>
                <div className="absolute bg-[url('images/sparkle.webp')] w-full h-full top-4"></div>
            </div>
        </div>
    )
}
